import React, { useEffect, useState } from "react";
import { useAppDispatch, useAppSelector } from "../../../redux/app/hooks";
import DateRangeSelector, { DateRangeType } from "../../ui/DateRangeSelector";
import {
  clearAnalyticsData,
  fetchDetailedAnalyticsAsync,
} from "../../../redux/features/analyticsSlice";
import moment from "moment";
import CustomTable from "../../../components/Tables/CustomTable";
import WhiteTitledCard from "../../../components/cards/WhiteTitledCard";
import FilterByButton from "../../ui/FilterButton";
import {
  contractColumns,
  contractRows,
  revenueColumns,
  revenueRows,
  userColumns,
  userRows,
} from "./tableUtils";

const DetailedAnalytics = () => {
  const [selectedRange, setSelectedRange] = useState<DateRangeType>({
    startDate: new Date(moment().startOf("day").toISOString()),
    endDate: new Date(moment().endOf("day").toISOString()),
  });
  const { user } = useAppSelector((state) => state.auth);
const [analyticsType, setAnalyticsType] = useState(() =>
  user?.user?.roles === "INVESTOR" ? "users" : "revenue"
);
  const [limit, setLimit] = useState<number>(10);
  const [page, setPage] = useState<number>(0);
  const { loading, detailedAnalytics } = useAppSelector(
    (state) => state.analytics
  );
  const dispatch = useAppDispatch();

  const handleDateChange = (range: DateRangeType) => {
    setSelectedRange(range);
  };

const analyticsTypeOptions = [
  ...(user?.user?.roles !== "INVESTOR"
    ? [{ label: "Revenue", value: "revenue" }]
    : []),
  { label: "Users", value: "users" },
  { label: "Contracts", value: "contracts" },
];


  useEffect(() => {
    dispatch(clearAnalyticsData());
    dispatch(
      fetchDetailedAnalyticsAsync({
        type: analyticsType,
        page: page + 1,
        limit,
        startDate: selectedRange.startDate,
        endDate: selectedRange.endDate,
      })
    );
  }, [analyticsType, page, limit, selectedRange, dispatch]);

  const data = {
    columns:
      analyticsType === "revenue"
        ? revenueColumns
        : analyticsType === "users"
        ? userColumns
        : contractColumns,

    rows:
      analyticsType === "revenue"
        ? revenueRows(detailedAnalytics?.data ?? [])
        : analyticsType === "users"
        ? userRows(detailedAnalytics?.data ?? [])
        : contractRows(detailedAnalytics?.data ?? []),
  };

  useEffect(() => {
    user?.user?.roles === "INVESTOR" && setAnalyticsType("users");
  }, [user?.user?.roles]);

  return (
    <div className="p-6 flex flex-col gap-6">
      <p className="text-2xl font-bold capitalize">{analyticsType} Analytics</p>
      <WhiteTitledCard>
        <div className="p-4">
          <div className="flex flex-col md:justify-between gap-4 mb-4">
            {/* Tabs List */}
            {/* Search and Filter */}
            <div className="flex flex-col sm:flex-row items-stretch sm:items-center justify-between gap-2 w-full md:w-auto">
              <div className="flex gap-2">
                <DateRangeSelector
                  initialRange={selectedRange}
                  onChange={handleDateChange}
                />
              </div>
              <div className="flex gap-2">
                <FilterByButton
                  options={analyticsTypeOptions}
                  onSelect={(value) => {
                    setAnalyticsType(value);
                  }}
                  buttonLabel="Analytic Type"
                  defaultValue={analyticsType}
                />
              </div>
            </div>
            <div className="flex flex-col md:flex-row flex-wrap items-center gap-3"></div>
          </div>

          <CustomTable
            data={data}
            noRecordText="Record is Empty"
            loading={loading}
            showFooter={true}
            totalPages={Math.ceil(
              Number(detailedAnalytics?.total) /
                Number(detailedAnalytics?.limit)
            )}
            itemsPerPage={detailedAnalytics?.data?.limit}
            currentPage={page}
            onPageChange={(value: number) => setPage(value)}
            onLimitChange={(value: number) => {
              setLimit(value);
              setPage(0);
            }}
          />
        </div>
      </WhiteTitledCard>
    </div>
  );
};

export default DetailedAnalytics;
